import {useCallback} from 'react';
import {Settings} from './app';
import {EntryData, generateUniqueEntry} from './math';

export function createEntries(settings: Settings) {
  const {operation, mode, range, entriesAmount, baseFactor} = settings;
  const entries: EntryData[] = [];
  const maxDivisionAmount = Math.abs(range.max / (baseFactor ?? 1));
  const maxEntries =
    operation === 'divide' && maxDivisionAmount < entriesAmount
      ? maxDivisionAmount
      : entriesAmount;

  for (let i = 0; i < maxEntries; i++) {
    const entry = generateUniqueEntry(
      entries,
      {min: range.min, max: range.max},
      operation,
      mode,
      baseFactor
    );
    entries.push(entry);
  }
  return entries;
}
